export type ToastrSnackbarVariant = 'success' | 'error' | 'warning' | 'info';

export function mapToastTypeToVariant(toastType: string): ToastrSnackbarVariant {
  switch (toastType) {
    case 'toast-success':
      return 'success';
    case 'toast-error':
      return 'error';
    case 'toast-warning':
      return 'warning';
    case 'toast-info':
    default:
      return 'info';
  }
}
